import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import UFOSegment from '@atlaskit/react-ufo/segment';

import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { ProductPageNav } from '@/patterns/global-nav/src/product-page-nav';

type EnterprisePageProductNavProps = {
	readonly isActive?: 'overview' | 'success' | 'resources';
};

const enterpriseNavTitleStyle = css({
	display: 'flex',
	alignItems: 'center',
	height: '100%',
	fontWeight: '700',
	fontSize: '20px',
	lineHeight: '20px',
	whiteSpace: 'nowrap',
});

export const EnterprisePageProductNav = ({ isActive }: EnterprisePageProductNavProps) => {
	const intl = useIntl();

	const ctaButtonText = intl.formatMessage({
		id: 'EnterpriseLandingPage.navbar.cta',
		defaultMessage: 'Contact sales',
	});

	const mobileCtaButtonText = intl.formatMessage({
		id: 'EnterpriseLandingPage.navbar.mobile.cta',
		defaultMessage: 'Contact sales',
	});
	const links = [
		{
			globalLinksKey: 'overview',
			linkText: intl.formatMessage({
				id: 'EnterpriseLandingPage.navbar.overview',
				defaultMessage: 'Overview',
			}),
			hasDropdown: false,
			isActive: isActive === 'overview',
			productKey: 'enterprise',
			href: useLocalizedHref('/enterprise'),
		},
		{
			globalLinksKey: 'success',
			linkText: intl.formatMessage({
				id: 'EnterpriseLandingPage.navbar.success',
				defaultMessage: 'Success',
			}),
			hasDropdown: false,
			isActive: isActive === 'success',
			productKey: 'enterprise',
			href: useLocalizedHref('/enterprise/success'),
		},
		{
			globalLinksKey: 'resources',
			linkText: intl.formatMessage({
				id: 'EnterpriseLandingPage.navbar.resources',
				defaultMessage: 'Resources',
			}),
			hasDropdown: false,
			isActive: isActive === 'resources',
			productKey: 'enterprise',
			href: useLocalizedHref('/enterprise/resources'),
		},
	];

	return (
		<UFOSegment name="enterprise-page-product-navigation">
			<ProductPageNav
				productLogoUrl={useLocalizedHref('/enterprise')}
				productLogo={<div css={enterpriseNavTitleStyle}>Enterprise</div>}
				productLogoAriaLabel="Enterprise"
				productPageNavLinks={links}
				mobileLinksSections={[
					{
						mobileLinkKey: 'mobile-enterprise',
						mobileLinksProps: links,
					},
				]}
				navigationTrynowCtaText={ctaButtonText}
				navigationTrynowCtaUrl={useLocalizedHref('/enterprise/contact?formType=product-features')}
				mobileCtaText={mobileCtaButtonText}
				mobileCtaUrl={useLocalizedHref('/enterprise/contact?formType=product-features')}
			/>
		</UFOSegment>
	);
};

export default EnterprisePageProductNav;
